import {agendaDirectory} from "./access/patientDirectory";
import { useEffect, useState } from "react";
import { db } from "./firebase";
import { useClinic } from "./context/ClinicContext";
import { collection, onSnapshot } from "./access/firestore";
import CitaForm from "./CitaForm";
import {
  getDeviceTimeZone,
  localizeScheduleEntry
} from "./utils/timezone";
import {

  CalendarDays,
  CalendarRange,
  Calendar1,
  List,
  Plus,
  ChevronLeft,
  ChevronRight,
  TriangleAlert,
  Clock3,
  Wallet

} from "lucide-react";

export default function CalendarCitas({
  fechaInicial
}) {

  const { clinicId } = useClinic();
  const deviceTimeZone = getDeviceTimeZone();

  const [citas, setCitas] = useState([]);
  const [bloqueos, setBloqueos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);

  const [fechaActual, setFechaActual] = useState(new Date());
  const [ahora, setAhora] = useState(() => new Date());

  useEffect(() => {
    const actualizarReloj = () => setAhora(new Date());

    actualizarReloj();
    const intervalo = window.setInterval(actualizarReloj, 30 * 1000);

    return () => window.clearInterval(intervalo);
  }, []);

  useEffect(() => {

    if (!fechaInicial) {
      return;
    }

    const partes =
      fechaInicial
        .split("-")
        .map(Number);

    if (partes.length !== 3) {
      return;
    }

    const [
      year,
      month,
      day
    ] = partes;

    if (
      !year ||
      !month ||
      !day
    ) {
      return;
    }

    setFechaActual(
      new Date(
        year,
        month - 1,
        day
      )
    );

    setView("dia");

  }, [fechaInicial]);
  const [
    mostrarSelectorFecha,
    setMostrarSelectorFecha
  ] = useState(false);
  const font = {
    fontFamily: "Inter, system-ui, Arial",
    fontSize: "13px"
  };

  const [view, setView] = useState("dia");

  const [
    mostrarSoloPendientes,
    setMostrarSoloPendientes
  ] = useState(false);

  const citasPendientes =
    citas.filter(c =>
      !c.pacienteId
  );

  useEffect(() => {

    if (!clinicId) return;

    return onSnapshot(

      agendaDirectory(db,clinicId),

      snap => {

        setCitas(

          snap.docs
            .map(d =>
              localizeScheduleEntry(
                { id: d.id, ...d.data() },
                deviceTimeZone
              )
            )
            .sort((a,b)=>
              (a.hora || "")
                .localeCompare(b.hora || "")
            )

        );
      }

    );

  }, [clinicId, deviceTimeZone]);

  useEffect(() => {
    if (!clinicId) {
      setBloqueos([]);
      return;
    }

    return onSnapshot(
      collection(db, "clinics", clinicId, "bloqueosAgenda"),
      (snap) => {
        setBloqueos(
          snap.docs.map((d) =>
            localizeScheduleEntry(
              {
                id: d.id,
                ...d.data(),
                tipo: "bloqueoAgenda"
              },
              deviceTimeZone
            )
          )
        );
      },
      (error) => {
        console.error(
          "Error cargando bloqueos de agenda:",
          error
        );
      }
    );
  }, [clinicId, deviceTimeZone]);

  const formatDateKey = (date) => {
    return date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, "0") + "-" +
      String(date.getDate()).padStart(2, "0");
  };

  const citasHoy =
  citas.filter(
    c =>
      formatDateKey(
        new Date(c.fecha)
        ) === formatDateKey(ahora)
  );

  const totalHoy =
    citasHoy.length;

  const totalPendientes =
    citas.filter(
      c =>
        c.estado === "pendiente"
    ).length;

  const ingresosHoy =
    citasHoy.reduce(

      (total,c)=>

        total +

        Number(
          c.presupuesto || 0
        ),

      0

    );

  const formatFecha = (date) => {
    return date.toLocaleDateString("es-MX", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };

  const formatFechaSemana = (date) => {
    return date.toLocaleDateString("es-MX", {
      weekday: "short",
      day: "2-digit",
      month: "long"
    });
  };

  const fechaKey = formatDateKey(fechaActual);

  const citasFiltradas = mostrarSoloPendientes
    ? citas.filter(c => !c.pacienteId)
    : citas;

  const eventosAgenda = [
    ...citasFiltradas,
    ...bloqueos.map(b => ({
      ...b,
      tipo: "bloqueoAgenda",
      estado: "bloqueo",
      hora: b.horaInicio,
      duracion: Math.max(
        15,
        (
          Number(b.horaFin?.split(":")[0] || 0) * 60 +
          Number(b.horaFin?.split(":")[1] || 0)
        ) -
        (
          Number(b.horaInicio?.split(":")[0] || 0) * 60 +
          Number(b.horaInicio?.split(":")[1] || 0)
        )
      ),
      pacienteNombre: b.motivo,
      nombrePaciente: b.motivo
    }))
  ];

  const citasPorFecha = eventosAgenda.reduce((acc, evento) => {
    if (!evento.fecha) return acc;
    if (!acc[evento.fecha]) acc[evento.fecha] = [];
    acc[evento.fecha].push(evento);
    return acc;
  }, {});


  // 🔥 COLORES GLOBAL
  const getBg = (estado) => {

    if (estado === "bloqueo") {
      return "#e2e8f0";
    }

    if (estado === "cancelada") {
      return "#fee2e2";
    }

    if (estado === "confirmada") {
      return "#dcfce7";
    }

    if (estado === "pagada") {
      return "#bbf7d0";
    }

    return "#e0f2fe";
  };

  const btn = {
    padding: "8px 14px",
    borderRadius: 10,
    border: "none",
    background: "#93c5fd",
    color: "#1e3a8a",
    cursor: "pointer"
  };

  const card = {

    background:"#ffffff",

    border:"1px solid #e2e8f0",

    borderRadius:20,

    padding:18,

    boxShadow:"0 4px 18px rgba(15,23,42,.05)",

    transition:"all .2s ease"

  };

  // 🔥 NAVEGACIÓN
  const irHoy = () =>
    setFechaActual(new Date());

  const irAFecha = (valor) => {

    if (!valor) return;

    const [
      year,
      month,
      day
    ] = valor.split("-").map(Number);

    setFechaActual(
      new Date(
        year,
        month - 1,
        day
      )
    );

    setMostrarSelectorFecha(false);

  };

  const siguiente = () => {
    const d = new Date(fechaActual);
    if (view === "dia") d.setDate(d.getDate() + 1);
    if (view === "semana") d.setDate(d.getDate() + 7);
    if (view === "mes") d.setMonth(d.getMonth() + 1);
    setFechaActual(d);
  };

  const anterior = () => {
    const d = new Date(fechaActual);
    if (view === "dia") d.setDate(d.getDate() - 1);
    if (view === "semana") d.setDate(d.getDate() - 7);
    if (view === "mes") d.setMonth(d.getMonth() - 1);
    setFechaActual(d);
  };

  const getWeek = () => {
    const start = new Date(fechaActual);
    start.setDate(start.getDate() - start.getDay());

    return Array.from({ length: 7 }).map((_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return d;
    });
  };

  const getMonthGrid = () => {
    const start = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    const end = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);

    const startDay = start.getDay();
    const totalDays = end.getDate();

    const grid = [];

    for (let i = 0; i < startDay; i++) grid.push(null);

    for (let i = 1; i <= totalDays; i++) {
      grid.push(new Date(fechaActual.getFullYear(), fechaActual.getMonth(), i));
    }

    return grid;
  };

  
  
  const renderCita = (c, compacto = false) => {
    if (c.tipo === "bloqueoAgenda") {
      return (
        <div className="vd-calendar-event vd-calendar-event-blocked"
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            width: "100%",
            height: "100%",
            minWidth: 0,
            minHeight: 0,
            boxSizing: "border-box",
            padding: compacto ? "2px 4px" : "8px 10px",
            borderRadius: 9,
            background: "#e2e8f0",
            border: "1px solid #cbd5e1",
            borderLeft: "4px solid #64748b",
            color: "#334155",
            fontSize: compacto ? 10 : 12,
            lineHeight: 1.3,
            overflow: "hidden"
          }}
        >
          <Clock3 size={compacto ? 12 : 15} />
          <div style={{ minWidth: 0, overflow: "hidden" }}>
            <div style={{
              fontWeight: 750,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}>
              {c.motivo || "Bloqueo de agenda"}
            </div>
            {!compacto && (
              <div style={{ marginTop: 3, fontSize: 11 }}>
                {c.horaInicio} – {c.horaFin}
                {c.alcance === "todos"
                  ? " · Toda la agenda"
                  : c.doctorNombre
                    ? ` · ${c.doctorNombre}`
                    : ""}
              </div>
            )}
          </div>
        </div>
      );
    }
    const pendiente = !c.pacienteId;
    const hora = c.hora || "--:--";
    const presupuesto = Number(c.presupuesto || 0).toLocaleString("es-MX");

    const obtenerMinutos = (valor) => {
      if (typeof valor === "number") return valor;

      const texto = String(valor || "60");
      const partes = texto.split(":");

      if (partes.length === 2) {
        return Number(partes[0]) * 60 + Number(partes[1]);
      }

      return Number(texto) || 60;
    };

    const duracion = Math.max(15, obtenerMinutos(c.duracion));

    const [horasInicio, minutosInicio] = hora.split(":").map(Number);
    const totalMinutos = (horasInicio || 0) * 60 + (minutosInicio || 0) + duracion;

    const horaFin = `${String(Math.floor(totalMinutos / 60) % 24).padStart(2, "0")}:${String(totalMinutos % 60).padStart(2, "0")}`;

    const formatearHora = (valor) => {
      const [h, m] = valor.split(":").map(Number);
      const periodo = h >= 12 ? "pm" : "am";
      const hora12 = h % 12 || 12;
      return `${hora12}:${String(m).padStart(2, "0")} ${periodo}`;
    };

    return (
      <div className="vd-calendar-event"
        style={{
          display: "flex",
          alignItems: "stretch",
          height: "100%",
          minHeight: 0,
          boxSizing: "border-box",
          borderRadius: 12,
          overflow: "hidden",
          background: getBg(c.estado),
          border: "1px solid rgba(148,163,184,.25)",
          borderLeft: pendiente ? "4px solid #facc15" : "4px solid rgba(37,99,235,.3)",
          boxShadow: pendiente ? "0 0 0 1px #fde68a" : "0 2px 6px rgba(15,23,42,.04)",
          cursor: "pointer"
        }}
      >        
        
        
        
        <div
          style={{
            flex: 1,
            minWidth: 0,
            padding: compacto ? "3px 7px" : duracion <= 30 ? "2px 5px" : "4px 8px",
            display: compacto ? "flex" : "grid",
            gridTemplateColumns: compacto
              ? undefined
              : duracion <= 30
                ? "minmax(0, 1fr) auto"
                : duracion <= 60
                  ? "minmax(0, 1fr) minmax(0, 1fr)"
                  : "minmax(0, 1fr)",
            gridAutoRows: "min-content",
            alignItems: "center",
            alignContent: "start",
            justifyContent: "start",
            flexWrap: "nowrap",
            textAlign: "left",
            gap: compacto ? 0 : duracion <= 30 ? "2px 8px" : duracion <= 60 ? "3px 10px" : 7,
            boxSizing: "border-box",
            minHeight: 0,
            overflow: compacto ? "hidden" : "visible",
            fontSize: duracion <= 30 ? 10 : 11,
            lineHeight: 1.15,
          }}
        >
          {compacto ? (
            <span
              title={c.pacienteNombre || "Paciente sin asignar"}
              style={{
                display: "block",
                width: "100%",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: 11,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              {c.pacienteNombre || "Paciente sin asignar"}
            </span>
          ) : (
            <>
              <span
                style={{
                  minWidth: 0,
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#0f172a",
                  overflowWrap: "anywhere",
                }}
              >
                {c.pacienteNombre || "Paciente sin asignar"}
              </span>

              <span
                style={{
                  justifySelf: "start",
                  background: "#eff6ff",
                  color: "#2563eb",
                  padding: "2px 5px",
                  borderRadius: 999,
                  fontSize: 9,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {c.estado || "Activa"}
              </span>

              <span style={{ minWidth: 0, color: "#475569", overflowWrap: "anywhere" }}>
                Doctor: {c.doctorNombre || "Sin asignar"}
              </span>

              <span style={{ minWidth: 0, color: "#475569", overflowWrap: "anywhere" }}>
                Horario: {formatearHora(hora)} – {formatearHora(horaFin)}
              </span>

              <span style={{ minWidth: 0, color: "#475569" }}>
                Costo: ${presupuesto}
              </span>

              <span style={{ minWidth: 0, color: "#475569", overflowWrap: "anywhere" }}>
                Tratamiento: {c.motivo || "No especificado"}
              </span>

              {pendiente && (
                <span style={{ color: "#92400e", fontWeight: 600 }}>
                  Sin paciente asignado
                </span>
              )}
            </>
          )}
        </div>

      </div>
    );
  };

  const agruparCitasPorHora = (listaCitas) => {
    const grupos = {};

    listaCitas.forEach(c => {
      const hora = c.hora || "--:--";

      if (!grupos[hora]) {
        grupos[hora] = [];
      }

      grupos[hora].push(c);
    });

    return Object.entries(grupos).sort(
      ([horaA], [horaB]) => horaA.localeCompare(horaB)
    );
  };

  return (
    <div className="vd-module-page vd-calendar-page" style={{ padding: 20, ...font }}>

      <div className="vd-calendar-hero"
        style={{
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
          marginBottom:24,
          flexWrap:"wrap",
          gap:20
        }}
      >

        <div
          style={{
            display:"flex",
            alignItems:"center",
            gap:18
          }}
        >

          <div
            style={{
              width:60,
              height:60,
              borderRadius:18,
              background:"#dbeafe",
              display:"flex",
              justifyContent:"center",
              alignItems:"center",
              flexShrink:0
            }}
          >

            <CalendarDays
              size={30}
              color="#2563eb"
            />

          </div>

          <div>

            <div
              style={{
                fontSize:28,
                fontWeight:700,
                color:"#0f172a"
              }}
            >

              Citas

            </div>

            <div
              style={{
                marginTop:4,
                color:"#64748b",
                fontSize:15
              }}
            >

              Agenda y administra las citas de tu consultorio.

            </div>

          </div>

        </div>

      </div>

      {/* RESUMEN */}

      <div className="vd-calendar-summary"
        style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
          gap:18,
          marginBottom:26
        }}
      >

        {/* HOY */}

        <div className="vd-calendar-stat vd-calendar-stat-blue"
          style={{
            background:"#ffffff",
            border:"1px solid #e2e8f0",
            borderRadius:20,
            padding:22,
            boxShadow:"0 4px 18px rgba(15,23,42,.05)"
          }}
        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:12,
              marginBottom:18
            }}
          >

            <div
              style={{
                width:46,
                height:46,
                borderRadius:14,
                background:"#dbeafe",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}
            >

              <CalendarDays
                size={22}
                color="#2563eb"
              />

            </div>

            <div>

              <div
                style={{
                  fontSize:14,
                  color:"#64748b"
                }}
              >

                Citas de hoy

              </div>

              <div
                style={{
                  fontSize:28,
                  fontWeight:700
                }}
              >

                {totalHoy}

              </div>

            </div>

          </div>

        </div>

        {/* PENDIENTES */}

        <div className="vd-calendar-stat vd-calendar-stat-amber"
          style={{
            background:"#ffffff",
            border:"1px solid #e2e8f0",
            borderRadius:20,
            padding:22,
            boxShadow:"0 4px 18px rgba(15,23,42,.05)"
          }}
        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:12,
              marginBottom:18
            }}
          >

            <div
              style={{
                width:46,
                height:46,
                borderRadius:14,
                background:"#fef3c7",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}
            >

              <TriangleAlert
                size={22}
                color="#d97706"
              />

            </div>

            <div>

              <div
                style={{
                  fontSize:14,
                  color:"#64748b"
                }}
              >

                Pendientes

              </div>

              <div
                style={{
                  fontSize:28,
                  fontWeight:700
                }}
              >

                {totalPendientes}

              </div>

            </div>

          </div>

        </div>

        {/* Ingresos hoy */}

        <div className="vd-calendar-stat vd-calendar-stat-green"
          style={{
            background:"#ffffff",
            border:"1px solid #e2e8f0",
            borderRadius:20,
            padding:22,
            boxShadow:"0 4px 18px rgba(15,23,42,.05)"
          }}
        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:12,
              marginBottom:18
            }}
          >

            <div
              style={{
                width:46,
                height:46,
                borderRadius:14,
                background:"#dcfce7",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}
            >

              <Wallet
                size={22}
                color="#16a34a"
              />

            </div>

            <div>

              <div
                style={{
                  fontSize:14,
                  color:"#64748b"
                }}
              >

                Ingresos hoy

              </div>

              <div
                style={{
                  fontSize:28,
                  fontWeight:700,
                  color:"#16a34a"
                }}
              >

                {

                  ingresosHoy > 0

                    ? `$${ingresosHoy.toLocaleString("es-MX")}`

                    : "Sin ingresos"

                }

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* 🔥 BARRA DE ACCIONES */}

      <div className="vd-calendar-toolbar"
        style={{
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
          gap:20,
          marginBottom:24,
          flexWrap:"wrap"
        }}
      >

        <div
          style={{
            display:"flex",
            gap:10,
            flexWrap:"wrap"
          }}
        >

          <button
  onClick={() => {

    setCitaSeleccionada(null);

    setShowForm(true);

  }}
            style={{
              height:48,
              padding:"0 18px",
              border:"none",
              borderRadius:14,
              background:"#2563eb",
              color:"#fff",
              fontWeight:700,
              fontSize:15,
              display:"flex",
              alignItems:"center",
              gap:10,
              cursor:"pointer",
              boxShadow:"0 2px 8px rgba(37,99,235,.18)"
            }}
          >

            <Plus size={18}/>

            Agregar cita

          </button>

          <button
            onClick={()=>setView("lista")}
            style={{
              ...btn,
              background:
                view==="lista"
                  ? "#2563eb"
                  : "#f1f5f9",
              color:
                view==="lista"
                  ? "#fff"
                  : "#334155",
              display:"flex",
              alignItems:"center",
              gap:8,
              height:48,
              borderRadius:14,
              fontWeight:600
            }}
          >

            <List size={17}/>

            Lista

          </button>

          <button
            onClick={()=>setView("dia")}
            style={{
              ...btn,
              background:
                view==="dia"
                  ? "#2563eb"
                  : "#f1f5f9",
              color:
                view==="dia"
                  ? "#fff"
                  : "#334155",
              display:"flex",
              alignItems:"center",
              gap:8,
              height:48,
              borderRadius:14,
              fontWeight:600
            }}
          >

            <Calendar1 size={17}/>

            Día

          </button>

          <button
            onClick={()=>setView("semana")}
            style={{
              ...btn,
              background:
                view==="semana"
                  ? "#2563eb"
                  : "#f1f5f9",
              color:
                view==="semana"
                  ? "#fff"
                  : "#334155",
              display:"flex",
              alignItems:"center",
              gap:8,
              height:48,
              borderRadius:14,
              fontWeight:600
            }}
          >

            <CalendarRange size={17}/>

            Semana

          </button>

          <button
            onClick={()=>setView("mes")}
            style={{
              ...btn,
              background:
                view==="mes"
                  ? "#2563eb"
                  : "#f1f5f9",
              color:
                view==="mes"
                  ? "#fff"
                  : "#334155",
              display:"flex",
              alignItems:"center",
              gap:8,
              height:48,
              borderRadius:14,
              fontWeight:600
            }}
          >

            <CalendarDays size={17}/>

            Mes

          </button>

          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{
              position:"relative"
            }}
          >

            <button
              onClick={(e) => {

                e.stopPropagation();

                setMostrarSelectorFecha(
                  !mostrarSelectorFecha
                );

              }}
              style={{
                ...btn,
                height:48,
                padding:"0 15px",
                borderRadius:14,
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                gap:8,
                background:"#f1f5f9",
                color:"#334155",
                fontWeight:600
              }}
              title="Ir a una fecha"
            >

              <CalendarDays
                size={18}
              />

              <span>
                Ir a fecha
              </span>

            </button>

            {mostrarSelectorFecha && (

              <>
                
                {/* =========================
                    FONDO PARA CERRAR AL HACER CLICK AFUERA
                ========================= */}

                <div
                  onClick={() => {
                    setMostrarSelectorFecha(false);
                  }}
                  style={{
                    position:"fixed",
                    inset:0,
                    zIndex:999,
                    background:"transparent"
                  }}
                />

                {/* =========================
                    SELECTOR DE FECHA
                ========================= */}

                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  style={{
                    position:"absolute",
                    top:"calc(100% + 8px)",
                    right:0,
                    zIndex:1000,
                    background:"#ffffff",
                    border:"1px solid #e2e8f0",
                    borderRadius:16,
                    padding:14,
                    boxShadow:
                      "0 10px 30px rgba(15,23,42,.15)"
                  }}
                >

                  <div
                    style={{
                      display:"flex",
                      alignItems:"center",
                      gap:8,
                      marginBottom:10,
                      color:"#334155",
                      fontWeight:600,
                      fontSize:14
                    }}
                  >

                    <CalendarDays
                      size={18}
                      color="#2563eb"
                    />

                    Ir a una fecha

                  </div>

                  <input
                    type="date"
                    value={fechaKey}
                    onChange={(e) =>
                      irAFecha(e.target.value)
                    }
                    autoFocus
                    style={{
                      height:44,
                      border:"1px solid #cbd5e1",
                      borderRadius:10,
                      padding:"0 10px",
                      fontSize:15,
                      color:"#1e293b",
                      outline:"none",
                      cursor:"pointer"
                    }}
                  />

                </div>

              </>

            )}

          </div>

        </div>

        <div
          style={{
            display:"flex",
            gap:10
          }}
        >

          <button
            onClick={anterior}
            style={{
              ...btn,
              height:48,
              width:48,
              borderRadius:14,
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              background:"#f1f5f9",
              color:"#334155"
            }}
          >

            <ChevronLeft size={18}/>

          </button>

          <button
            onClick={irHoy}
            style={{
              height:48,
              padding:"0 18px",
              border:"none",
              borderRadius:14,
              background:"#2563eb",
              color:"#fff",
              fontWeight:700,
              cursor:"pointer"
            }}
          >

            Hoy

          </button>

          <button
            onClick={siguiente}
            style={{
              ...btn,
              height:48,
              width:48,
              borderRadius:14,
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              background:"#f1f5f9",
              color:"#334155"
            }}
          >

            <ChevronRight size={18}/>

          </button>

        </div>

      </div>

      {

        citasPendientes.length > 0 && (

          <div
            style={{
              marginBottom:24,
              background:"#fffbeb",
              border:"1px solid #fde68a",
              borderRadius:18,
              padding:"18px 22px",
              display:"flex",
              justifyContent:"space-between",
              alignItems:"center",
              gap:24,
              flexWrap:"wrap"
            }}
          >

            <div
              style={{
                display:"flex",
                alignItems:"flex-start",
                gap:16
              }}
            >

              <div
                style={{
                  width:48,
                  height:48,
                  borderRadius:14,
                  background:"#fef3c7",
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center"
                }}
              >

                <TriangleAlert
                  size={22}
                  color="#d97706"
                />

              </div>

              <div>

                <div
                  style={{
                    fontWeight:700,
                    fontSize:16,
                    color:"#92400e"
                  }}
                >

                  {citasPendientes.length} cita{citasPendientes.length>1?"s":""} pendiente{citasPendientes.length>1?"s":""} de vincular

                </div>

                <div
                  style={{
                    marginTop:4,
                    color:"#92400e",
                    fontSize:14,
                    lineHeight:1.5
                  }}
                >

                  Estas citas aún no están asignadas a un paciente de VexaDent.

                </div>

              </div>

            </div>

            <button

              onClick={()=>
                setMostrarSoloPendientes(
                  !mostrarSoloPendientes
                )
              }

              style={{
                height:46,
                padding:"0 18px",
                border:"none",
                borderRadius:14,
                background:
                  mostrarSoloPendientes
                    ? "#f59e0b"
                    : "#fde68a",
                color:"#78350f",
                fontWeight:700,
                cursor:"pointer"
              }}

            >

              {

                mostrarSoloPendientes
                  ? "Mostrar todas"
                  : "Ver solo pendientes"

              }

            </button>

          </div>

        )

      }

      {/* 🔥 LISTA */}

      {view === "lista" && Object.keys(citasPorFecha).map(f => (

        <div

          key={f}

          style={{

            ...card,

            marginBottom:22,

            padding:24

          }}

        >

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:10,
              marginBottom:18,
              paddingBottom:14,
              borderBottom:"1px solid #e2e8f0",
              fontSize:18,
              fontWeight:700,
              color:"#0f172a"
            }}
          >

            <CalendarDays
              size={20}
              color="#2563eb"
            />

            {f}

          </div>

          <div
            style={{
              display:"flex",
              flexDirection:"column",
              gap:14
            }}
          >

            {citasPorFecha[f].map(c => (

              <div

                key={c.id}

                onClick={() => {
                  if (c.tipo !== "bloqueoAgenda") {
                    setCitaSeleccionada(c);
                  }
                }}

                style={{

                  padding:14,

                  borderRadius:16,

                  background:getBg(c.estado),

                  border:"1px solid rgba(148,163,184,.18)",

                  boxShadow:"0 2px 8px rgba(15,23,42,.04)",

                  cursor:"pointer",

                  transition:"all .2s ease"

                }}

              >

                {renderCita(c)}

              </div>

            ))}

          </div>

        </div>

      ))}

      {/* 🔥 DÍA */}
      {view === "dia" && (
        <div className="vd-calendar-day-card" style={card}>
          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:12,
              marginBottom:22,
              paddingBottom:18,
              borderBottom:"1px solid #e2e8f0"
            }}
          >

            <CalendarDays
              size={24}
              color="#2563eb"
            />

            <div>

              <div
                style={{
                  fontSize:22,
                  fontWeight:700,
                  color:"#0f172a"
                }}
              >

                {formatFecha(fechaActual)}

              </div>

              <div
                style={{
                  color:"#64748b",
                  fontSize:14,
                  marginTop:4
                }}
              >

                Agenda del día

              </div>

            </div>

          </div>
          
            {(() => {
              const alturaHora = 72;
              const alturaMinuto = alturaHora / 60;

              const citasDia = (citasPorFecha[fechaKey] || [])
                .map(c => {
                  const [h, m] = String(c.hora || "00:00")
                    .split(":")
                    .map(Number);

                  const valorDuracion = String(c.duracion || "60");
                  const partes = valorDuracion.split(":");

                  const duracion = Math.max(
                    15,
                    partes.length === 2
                      ? (Number(partes[0]) || 0) * 60 +
                        (Number(partes[1]) || 0)
                      : Number(valorDuracion) || 60
                  );

                  return {
                    ...c,
                    inicioMinutos: (h || 0) * 60 + (m || 0),
                    duracionMinutos: duracion,
                  };
                })
                .sort((a, b) => a.inicioMinutos - b.inicioMinutos);

              const grupos = [];

              citasDia.forEach(c => {
                let grupo = grupos[grupos.length - 1];

                if (!grupo || c.inicioMinutos >= grupo.fin) {
                  grupo = {
                    fin: c.inicioMinutos + c.duracionMinutos,
                    citas: [],
                  };
                  grupos.push(grupo);
                } else {
                  grupo.fin = Math.max(
                    grupo.fin,
                    c.inicioMinutos + c.duracionMinutos
                  );
                }

                grupo.citas.push(c);
              });

              const citasPosicionadas = [];

              grupos.forEach(grupo => {
                const carriles = [];

                grupo.citas.forEach(c => {
                  let carril = carriles.findIndex(
                    fin => fin <= c.inicioMinutos
                  );

                  if (carril === -1) {
                    carril = carriles.length;
                    carriles.push(0);
                  }

                  carriles[carril] =
                    c.inicioMinutos + c.duracionMinutos;

                  citasPosicionadas.push({
                    ...c,
                    carril,
                    grupoId: grupos.indexOf(grupo),
                  });
                });

                grupo.totalCarriles = carriles.length;
              });

              return (
                <div className="vd-calendar-time-grid"
                  style={{
                    position: "relative",
                    paddingBottom: 0,
                  }}
                >
                  {Array.from({ length: 24 }).map((_, h) => (
                    <div
                      key={h}
                      onClick={() => setShowForm(true)}
                      style={{
                        height: alturaHora,
                        boxSizing: "border-box",
                        borderBottom: "1px solid #e2e8f0",
                        display: "grid",
                        gridTemplateColumns: "76px minmax(0, 1fr)",
                        gap: 10,
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "right",
                          paddingTop: 8,
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#64748b",
                        }}
                      >
                        {String(h).padStart(2, "0")}:00
                      </div>
                      <div />
                    </div>
                  ))}

                  {formatDateKey(ahora) === fechaKey && (
                    <div
                      className="vd-calendar-now-line"
                      style={{
                        top: Math.min(
                          24 * 60 - 1,
                          Math.max(
                            0,
                            (ahora.getHours() * 60 +
                              ahora.getMinutes() +
                              ahora.getSeconds() / 60) * alturaMinuto
                          )
                        ),
                      }}
                      aria-label={`Hora actual ${ahora.toLocaleTimeString("es-MX", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}`}
                    >
                      <span className="vd-calendar-now-line__label">
                        Ahora · {ahora.toLocaleTimeString("es-MX", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 86,
                      right: 0,
                      height: 24 * alturaHora,
                      pointerEvents: "none",
                    }}
                  >
                    {citasPosicionadas.map(c => {
                      const grupo = grupos[c.grupoId];
                      const totalCarriles = grupo.totalCarriles;
                      const ancho = 100 / totalCarriles;

                      return (
                        <div
                          key={c.id}
                          onClick={e => {
                            e.stopPropagation();
                            setShowForm(false);
                            setCitaSeleccionada(c);
                          }}
                          style={{
                            position: "absolute",
                            top: c.inicioMinutos * alturaMinuto,
                            left: `${c.carril * ancho}%`,
                            width: `${ancho}%`,
                            height: c.duracionMinutos * alturaMinuto,
                            padding: 2,
                            boxSizing: "border-box",
                            minWidth: 0,
                            pointerEvents: "auto",
                          }}
                        >
                          {renderCita(c)}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
        </div>
      )}

      {/* 🔥 SEMANA */}

      {view === "semana" && (

        <div
          style={{
            display:"grid",
            gridTemplateColumns:"repeat(auto-fit,minmax(230px,1fr))",
            gap:18
          }}
        >

          {getWeek().map(d => {

            const key = formatDateKey(d);

            const citas = citasPorFecha[key] || [];

            return (

              <div

                key={key}

                onClick={()=>{
                  setFechaActual(d);
                  setView("dia");
                }}

                style={{

                  ...card,

                  cursor:"pointer",

                  display:"flex",

                  flexDirection:"column",

                  minHeight:240,

                  transition:"all .2s ease"

                }}

              >

                {/* ENCABEZADO */}

                <div
                  style={{
                    display:"flex",
                    alignItems:"center",
                    gap:12,
                    paddingBottom:16,
                    marginBottom:18,
                    borderBottom:"1px solid #e2e8f0"
                  }}
                >

                  <div
                    style={{
                      width:42,
                      height:42,
                      borderRadius:12,
                      background:"#dbeafe",
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      flexShrink:0
                    }}
                  >

                    <CalendarDays
                      size={20}
                      color="#2563eb"
                    />

                  </div>

                  <div>

                    <div
                      style={{
                        fontWeight:700,
                        fontSize:15,
                        color:"#0f172a"
                      }}
                    >

                      {formatFechaSemana(d)}

                    </div>

                    <div
                      style={{
                        fontSize:12,
                        color:"#64748b",
                        marginTop:3
                      }}
                    >

                      {citas.length}

                      &nbsp;

                      cita{citas.length!==1 ? "s" : ""}

                    </div>

                  </div>

                </div>

                {/* CITAS */}
                
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    flex: 1,
                    minWidth: 0
                  }}
                >
                  {citas.length === 0 ? (
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#94a3b8",
                        fontSize: 14,
                        textAlign: "center"
                      }}
                    >
                      Sin citas
                    </div>
                  ) : (
                    agruparCitasPorHora(citas).map(([hora, citasHora]) => (
                      <div
                        key={hora}
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(min(100%, 180px), 1fr))",
                          gap: 6,
                          alignItems: "start",
                          minWidth: 0
                        }}
                      >
                        {citasHora.map(c => (
                          <div
                            key={c.id}
                            onClick={e => {
                              e.stopPropagation();
                              setShowForm(false);
                              setCitaSeleccionada(c);
                            }}
                            style={{
                              minWidth: 0,
                              height: 58,
                              overflow: "hidden",
                              borderRadius: 9
                            }}
                          >
                            {renderCita(c, true)}
                          </div>
                        ))}
                      </div>
                    ))
                  )}
                </div>

              </div>

            );

          })}

        </div>

      )}

      {/* 🔥 MES */}

      {view === "mes" && (

        <>

          <div
            style={{
              display:"flex",
              alignItems:"center",
              gap:14,
              marginBottom:24
            }}
          >

            <div
              style={{
                width:56,
                height:56,
                borderRadius:16,
                background:"#dbeafe",
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
                flexShrink:0
              }}
            >

              <CalendarDays
                size={28}
                color="#2563eb"
              />

            </div>

            <div>

              <div
                style={{
                  fontSize:24,
                  fontWeight:700,
                  color:"#0f172a",
                  textTransform:"capitalize"
                }}
              >

                {

                  fechaActual.toLocaleDateString(

                    "es-MX",

                    {

                      month:"long",

                      year:"numeric"

                    }

                  )

                }

              </div>

              <div
                style={{
                  marginTop:4,
                  color:"#64748b",
                  fontSize:14
                }}
              >

                Vista mensual

              </div>

            </div>

          </div>

          <div
            style={{
              display:"grid",
              gridTemplateColumns:"repeat(7,1fr)",
              gap:12,
              marginBottom:14
            }}
          >

            {

              ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"].map(d=>(

                <div

                  key={d}

                  style={{

                    textAlign:"center",

                    fontWeight:700,

                    color:"#64748b",

                    fontSize:13,

                    paddingBottom:8

                  }}

                >

                  {d}

                </div>

              ))

            }

          </div>

          <div
            style={{
              display:"grid",
              gridTemplateColumns:"repeat(7,1fr)",
              gap:12
            }}
          >

            {

              getMonthGrid().map((d,i)=>(

                <div

                  key={i}

                  onClick={()=>{

                    if(!d) return;

                    setFechaActual(d);

                    setView("dia");

                  }}

                  style={{

                    ...card,

                    minHeight:170,

                    padding:14,

                    cursor:d ? "pointer" : "default",

                    opacity:d ? 1 : .35,

                    display:"flex",

                    flexDirection:"column",

                    transition:"all .2s"

                  }}

                >

                  {

                    d && (

                      <>

                        <div
                          style={{
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:"center",
                            marginBottom:10
                          }}
                        >

                          <div
                            style={{
                              width:34,
                              height:34,
                              borderRadius:10,
                              background:"#eff6ff",
                              color:"#2563eb",
                              display:"flex",
                              justifyContent:"center",
                              alignItems:"center",
                              fontWeight:700
                            }}
                          >

                            {d.getDate()}

                          </div>

                          <div
                            style={{
                              fontSize:11,
                              color:"#64748b"
                            }}
                          >

                            {

                              (

                                citasPorFecha[
                                  formatDateKey(d)
                                ] || []

                              ).length

                            }

                          </div>

                        </div>
                        
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            flex: 1,
                            minHeight: 0,
                            overflow: "hidden"
                          }}
                        >
                          {(
                            citasPorFecha[formatDateKey(d)] || []
                          ).length === 0 ? (
                            <div
                              style={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#cbd5e1",
                                fontSize: 12
                              }}
                            >
                              Sin citas
                            </div>
                          ) : (
                            agruparCitasPorHora(
                              citasPorFecha[formatDateKey(d)] || []
                            ).map(([hora, citasHora]) => (
                              <div
                                key={hora}
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "repeat(auto-fit, minmax(min(100%, 110px), 1fr))",
                                  gap: 3,
                                  minWidth: 0
                                }}
                              >
                                {citasHora.map(c => (
                                  <div
                                    key={c.id}
                                    onClick={e => {
                                      e.stopPropagation();
                                      setShowForm(false);
                                      setCitaSeleccionada(c);
                                    }}
                                    style={{
                                      minWidth: 0,
                                      height: 34,
                                      overflow: "hidden",
                                      borderRadius: 6
                                    }}
                                  >
                                    {renderCita(c, true)}
                                  </div>
                                ))}
                              </div>
                            ))
                          )}
                        </div>

                      </>

                    )

                  }

                </div>

              ))

            }

          </div>

        </>

      )}

      {showForm && (
        <CitaForm
          bloqueos={bloqueos}
          onClose={() => {
            setShowForm(false);
            setCitaSeleccionada(null);
          }}
        />
      )}

      {citaSeleccionada && (
        <CitaForm
          cita={citaSeleccionada}
          bloqueos={bloqueos}
          onClose={() => {
            setCitaSeleccionada(null);
            setShowForm(false);
          }}
        />
      )}

    </div>
  );
}
